import React from 'react';
import { C } from './constants';
export function SectionIcon({
  children
}: {
  children: ReactNode;
}) {
  return <div style={{
    width: 42,
    height: 42,
    border: `2px solid ${C.gold}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: C.crimsonMid,
    background: C.goldPale,
    flexShrink: 0,
    boxShadow: `0 0 0 3px rgba(201,168,76,0.15)`
  }} data-id="element-371">
      {children}
    </div>;
}
export function SectionHeader({
  icon,
  title,
  subtitle
}: {
  icon: ReactNode;
  title: string;
  subtitle?: string;
}) {
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 20
  }} data-id="element-372">
      <SectionIcon data-id="element-373">{icon}</SectionIcon>
      <div data-id="element-374">
        <div style={{
        fontSize: 17,
        fontWeight: 700,
        color: C.crimson,
        fontFamily: 'Georgia,serif'
      }} data-id="element-375">
          {title}
        </div>
        {subtitle && <div style={{
        fontSize: 12,
        color: '#7a5c3a',
        marginTop: 2,
        fontStyle: 'italic'
      }} data-id="element-376">
            {subtitle}
          </div>}
      </div>
    </div>;
}
export function StandaloneTitle({
  icon,
  children
}: {
  icon: ReactNode;
  children: ReactNode;
}) {
  return <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontFamily: 'Georgia,serif',
    fontSize: 18,
    fontWeight: 700,
    color: C.crimson,
    marginBottom: 12,
    padding: '10px 14px',
    background: C.crimsonPale,
    borderLeft: `4px solid ${C.crimsonMid}`,
    borderRadius: '0 8px 8px 0'
  }} data-id="element-377">
      <svg viewBox="0 0 24 24" fill="none" stroke={C.crimsonMid} strokeWidth="2" style={{
      width: 22,
      height: 22,
      flexShrink: 0
    }} data-id="element-378">
        {icon}
      </svg>
      {children}
    </div>;
}